import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const RestaurantChips = ({ data }) => {
  const chips = [];

  if (!data) {
  return null;
}
  // Online Order chip
  if (data.onlineOrder) {
    chips.push({
      label: "Online Order",
      bgColor: "#4CAF50", // Green
    });
  }

  // Delivery chip - only show if onlineOrder is enabled
  if (data.onlineOrder && data.isDeliveryEnabled) {
    chips.push({
      label: "Delivery",
      bgColor: "#00BCD4", // Cyan
    });
  }

  // Take Away chip - only show if onlineOrder is enabled
  if (data.onlineOrder && data.isTakeAwayEnabled) {
    chips.push({
      label: "Take Away",
      bgColor: "#E91E63", // Pink
    });
  }

  // Table Order chip
  if (data.tableOrder) {
    chips.push({
      label: "Table Order",
      bgColor: "#2196F3", // Blue
    });
  }

  // Table Booking chip
  if (data.tableBookingOptions?.isEnabled) {
    const bookingType = data.tableBookingOptions.type || "classic";
    const formattedType = bookingType.charAt(0).toUpperCase() + bookingType.slice(1);
    chips.push({
      label: `Table Booking - ${formattedType}`,
      bgColor: "#9C27B0", // Purple
    });
  }

  // Gift Card chip
  if (data.giftCardOptions?.isPurchaseEnabled || data.giftCardOptions?.isRedemptionEnabled) {
    chips.push({
      label: "Gift Card",
      bgColor: "#FF9800", // Orange
    });
  }

  // Franchisee chip
  if (data.franchisee?.name) {
    chips.push({
      label: `Franchisee: ${data.franchisee.name}`,
      bgColor: "#FF6F00", // Amber
    });
  }

  if (chips.length === 0) {
    return null;
  }

  return (
    <Box sx={styles.chipContainer}>
      {chips.map((chip, index) => (
        <Typography key={index} sx={{ ...styles.chip, backgroundColor: chip.bgColor }}>
          {chip.label}
        </Typography>
      ))}
    </Box>
  );
};

export default RestaurantChips;

const styles = {
  chipContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: 0.7,
    mt: 0.5,
    mb: 1,
  },
  chip: {
    color: "#fff",
    fontFamily: "GilroySemiBold",
    fontSize: 10,
    borderRadius: 1,
    px: 1,
    py: 0.4,
  },
};
